(() => {
  for (const root of document.querySelectorAll('[data-quick-bundle]')) {
    if (root.dataset.initialized) continue;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-quick-form]');
    if (!form) continue;
    const strings = JSON.parse(root.querySelector('[data-quick-strings]').textContent);
    const slots = [null, null];
    let active = 0, busy = false;
    const submit = root.querySelector('[data-quick-submit]');
    const status = root.querySelector('[data-quick-status]');
    const track = (name, detail = {}) => window.DroplitFunnel?.track(name, { action: 'quick_bundle', ...detail });
    const hatLabels = { '48460549980345': 'Black Trucker', '48460550013113': 'White Trucker', '49115317928121': 'Two-Tone Canvas' };
    function render() {
      const hat = form.querySelector('input[name=id]:checked');
      submit.disabled = busy || !hat || !slots.every(Boolean);
      root.querySelectorAll('[data-quick-slot]').forEach((button, index) => {
        button.setAttribute('aria-pressed', String(index === active));
        button.querySelector('[data-slot-name]').textContent = slots[index]?.name || strings.tap;
      });
      root.querySelectorAll('[data-design-id]').forEach(button => {
        const selected = slots.map((slot, index) => slot?.id === button.dataset.designId ? index + 1 : null).filter(Boolean);
        button.dataset.selected = String(selected.length > 0);
        const badge = button.querySelector('[data-design-badge]');
        badge.hidden = !selected.length;
        badge.textContent = selected.join(' + ');
      });
      if (hat) root.querySelector('[data-quick-price]').textContent = hat.dataset.money;
      status.textContent = submit.disabled ? strings.select : strings.ready;
    }
    form.addEventListener('change', () => { render(); track('hat_selected', { hat: hatLabels[form.querySelector('input[name=id]:checked')?.value] }); });
    root.addEventListener('click', event => {
      if (busy) return;
      const button = event.target.closest('button');
      if (!button) return;
      if (button.hasAttribute('data-quick-slot')) { active = Number(button.dataset.quickSlot) - 1; render(); return; }
      if (!button.dataset.designId) return;
      slots[active] = { id: button.dataset.designId, name: button.dataset.designName, url: button.dataset.designUrl, version: button.dataset.designVersion };
      track('drop_saved', { slot: active + 1, source: 'library' });
      if (active === 0 && !slots[1]) active = 1;
      render();
      if (slots.every(Boolean)) track('bundle_completed');
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const hat = form.querySelector('input[name=id]:checked');
      if (busy || !hat || !slots.every(Boolean)) return;
      busy = true;
      submit.disabled = true;
      submit.textContent = strings.adding;
      status.textContent = strings.adding;
      const config = document.getElementById('droplit-analytics-config');
      const bundleId = crypto.randomUUID();
      const properties = { 'Hat Style': hatLabels[hat.value], '_DropLit Bundle ID': bundleId, '_DropLit Purchase Type': 'quick-bundle', '_Campaign': 'nfc-quick-bundle', '_DropLit Analytics Environment': config?.dataset.environment || 'testing', '_DropLit Analytics Theme': config?.dataset.themeId || '' };
      slots.forEach((slot,index) => {
        const number = index + 1;
        properties['Drop ' + number] = slot.name;
        properties['_Drop ' + number + ' Name'] = slot.name;
        properties['_Drop ' + number + ' Artwork'] = slot.url;
        properties['_Drop ' + number + ' Library ID'] = slot.id;
        properties['_Drop ' + number + ' Artwork Version'] = slot.version;
        properties['_Drop ' + number + ' Source'] = 'library';
        properties['_Drop ' + number + ' Scale'] = '100%';
        properties['_Drop ' + number + ' Left Right'] = '0';
        properties['_Drop ' + number + ' Up Down'] = '0';
      });
      track('add_to_cart_clicked');
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(hat.value),quantity:1,properties}]}) });
        const result = await response.json();
        if (!response.ok || !result.items?.some(item => item.properties?.['_DropLit Bundle ID'] === bundleId)) throw new Error(result.description || strings.error);
        track('add_to_cart_success', { value: Number(hat.dataset.price)/100 });
        track('checkout_clicked');
        location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
      } catch (error) {
        busy = false;
        submit.textContent = strings.checkout;
        render();
        status.textContent = error.message || strings.error;
        track('add_to_cart_error', { reason:'quick_bundle_failed' });
      }
    });
    async function loadLibrary() {
      const grid = root.querySelector('.dl-quick__designs');
      try {
        const designs = []; let after = '';
        do {
          const url = new URL('https://droplit-nfc.brian-1b8.workers.dev/api/library/catalog');
          url.searchParams.set('category', 'UT Quick Bundle');
          if (after) url.searchParams.set('after', after);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Library unavailable');
          const page = await response.json();
          designs.push(...page.designs.filter(d => d.artwork_url && d.artwork_version));
          after = page.next || '';
        } while (after);
        if (!designs.length) throw new Error('No approved designs');
        const fragment = document.createDocumentFragment();
        for (const design of designs.sort((a,b) => a.title.localeCompare(b.title))) {
          const button = document.createElement('button'); button.type = 'button'; button.className = 'dl-quick__design';
          button.dataset.designId = design.id; button.dataset.designName = design.title;
          button.dataset.designUrl = design.artwork_url; button.dataset.designVersion = design.artwork_version;
          button.setAttribute('aria-label', design.title);
          const img = document.createElement('img'); img.src = design.preview_url; img.alt = design.title; img.width = 320; img.height = 320; img.loading = 'lazy';
          const label = document.createElement('span'); label.textContent = design.title;
          const badge = document.createElement('b'); badge.dataset.designBadge = ''; badge.hidden = true;
          button.append(img, label, badge); fragment.append(button);
        }
        grid.replaceChildren(fragment); render();
      } catch (error) {
        grid.replaceChildren(); const message = document.createElement('p');
        message.textContent = 'Designs could not load. Please refresh to try again.'; grid.append(message);
      }
    }
    render();
    loadLibrary();
    track('builder_reached');
  }
})();
